import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const CheckCircleIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.87"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM6.95455 11.2985L9.81818 14.1194L17.0455 7L18 7.9403L9.81818 16L6 12.2388L6.95455 11.2985Z"
          fill="black"
        />
      </svg>
    )
  },
)
